<template>
  <button :id="id" :class="['chip', { 'chip--selected': selected }]" @click.prevent="e => $emit('click', e, id)">
    <div class="chip__text">{{ text }}</div>
    <slot></slot>
    <div class="chip__overlay" />
  </button>
</template>

<script>
export default {
  name: "AppChip",
  props: {
    id: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    selected: Boolean
  }
};
</script>

<style scoped lang="scss">
.chip {
  transition: background-color 0.5s;
  cursor: pointer;
  display: flex;
  position: relative;
  color: $group-3-color-3;
  font-weight: $font_regular;
  font-size: 14px;
  height: 32px;
  box-sizing: border-box;
  border: none;
  background-color: $group-3-color-1;
  border-radius: 16px;
  padding: 0;
  margin: 0;

  &__text {
    padding: 7px 16px 8px 16px;
  }

  &__overlay {
    transition: background-color 0.5s;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    opacity: 0;
  }

  @include hover-supported() {
    &:hover &__overlay {
      background-color: $group-3-color-4;
      opacity: 0.04;
    }
  }

  &:active &__overlay {
    transition: background-color 0s;
    background-color: black;
    opacity: 0.1;
  }

  &--selected {
    transition: background-color 0.5s;
    background-color: $group-3-color-4;
    color: $group-3-color-1;

    @include hover-supported() {
      &:hover {
        .chip__overlay {
          background-color: white;
          opacity: 0.16;
        }
      }
    }

    &:active {
      .chip__overlay {
        background-color: black;
        opacity: 0.1;
      }
    }
  }
}
</style>
